const InfoButton = ({func}) => {
    const OnClick = (event) => {
        event.preventDefault();
        func();
    }
    
    return <button
        type="button"
        aria-label="More information"
        className="flex h-10 w-10 items-center justify-center rounded-full bg-cyan-50 font-serif text-lg font-bold text-cyan-800 ring-1 ring-cyan-200 transition hover:-translate-y-0.5 hover:bg-cyan-100"
        onClick={e => OnClick(e)}
    >i</button>
}

export default InfoButton;
